import moment from 'moment';
import XLSX from 'xlsx';

const createExcelFromRequestsArray = (selectedRequests, requests) => {
  const h = [
    [
      'Тип',
      '№',
      'Статус',
      'Улица',
      'Дом',
      'Корпус',
      'Кв./офис',
      'Телефоны',
      'ФИО',
      'Сервис',
      'Причина',
      'Описание',
      'Создание',
      'Назн. выполнение',
      'Факт. выполнение',
      'Время',
      'Мастер',
      'Исполнитель',
      'Подрядчик',
      'Начало работ',
      'Окончание работ',
      'Последний комментарий',
      'Способ оплаты',
      'Сумма оплаты',
      'Статус оплаты',
    ],
  ];

  const r = selectedRequests.map((e) => {
    const req = requests.find((o) => {
      return o.id === e;
    });
    return [
      req.typeRequest,
      req.id,
      req.status,
      req.streetName,
      req.building,
      req.corpus,
      req.flat,
      req.contactPhones,
      req.clientName,
      req.parentService,
      req.service,
      req.description,
      req.createTime && moment(req.createTime).format('DD.MM.YYYY HH:mm'),
      req.executeTime && moment(req.executeTime).format('DD.MM.YYYY HH:mm'),
      req.doneDate && moment(req.doneDate).format('DD.MM.YYYY HH:mm'),
      req.executePeriod,
      req.master && req.master.fullName,
      req.executer && req.executer.fullName,
      req.warrantyInfo?.orgName && req.warrantyInfo.orgName,
      req.warrantyInfo?.beginDate &&
        moment(req.warrantyInfo.beginDate).format('DD.MM.YYYY HH:mm'),
      req.warrantyInfo?.endDate &&
        moment(req.warrantyInfo.endDate).format('DD.MM.YYYY HH:mm'),
      req.lastNote,
      req.paymentTypesName,
      req.invoice?.sum && Number((req.invoice.sum / 100).toFixed(2)),
      req.invoice?.paymentState?.name,
    ];
  });
  const ws = XLSX.utils.aoa_to_sheet(h.concat(r));

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Заявки');
  XLSX.writeFile(wb, 'Заявки.xlsx');
};

export default createExcelFromRequestsArray;
